import { MODELS, useModel } from "../../../../../../api";
import { UserDisplay } from "../../../../../../design-system/components/UserDisplay/UserDisplay.jsx";
import DeleteUserFromWorkshopButton from "../../../students/components/DeleteUserFromWorkshopButton/DeleteUserFromWorkshopButton.jsx";
import AssignOwnershipButton from "../AssignOwnerShipButton/AssignOwnershipButton.jsx";
import GroupBox from "../GroupBox/GroupBox.jsx";
import styles from "./TeacherList.css.ts";

/**
 * Checks if the provided user is the owner of the given workshop.
 *
 * @param {Object} workshop - The workshop object to be checked.
 * @param {Object} user - The user object to verify ownership against.
 * @return {boolean} True if the id of the owner of the workshop matches the id of the provided user, false otherwise.
 */
function isOwner(workshop, user) {
  if (!workshop.owner) return false;

  return Boolean(workshop.owner.id === user.id);
}

/**
 * Renders a list of teachers participating in a given workshop.
 *
 * @param {Object} params - The function parameters.
 * @param {Object} params.workshop - The workshop data object.
 * @return {JSX.Element|null} A component rendering the list of teachers, or null if no teachers are found.
 */
function TeacherList({ workshop }) {
  const userInfo = useModel(MODELS.WORKSHOP_USER_INFO(workshop.id));

  const teachers =
    userInfo &&
    userInfo.participants
      .filter((p) => p.role === "teacher")
      .sort((x, y) =>
        isOwner(workshop, x) ? -1 : isOwner(workshop, y) ? 1 : 0,
      );

  if (teachers.length === 0) return null;

  return (
    <GroupBox headline="Teilnehmende Lehrer*innen" highlighted>
      <ul className={styles.teacherList}>
        {teachers &&
          teachers.map((teacher) => (
            <li key={teacher.id}>
              <UserDisplay
                brighterBackground
                user={teacher}
                menuItems={
                  <>
                    <AssignOwnershipButton user={teacher} workshop={workshop} />

                    <DeleteUserFromWorkshopButton
                      workshop={workshop}
                      user={teacher}
                    />
                  </>
                }
                highlight={isOwner(workshop, teacher)}
              />
            </li>
          ))}
      </ul>
    </GroupBox>
  );
}

export default TeacherList;
